// client/src/components/catalogoModelo/ImportarCategoriaModal.js
import React, { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import FormModal from '../layout/FormModal';
import ResultadoImportacaoTable from './ResultadoImportacaoTable';
import { useImportarCategoriaCatalogo } from '../../hooks/useCatalogoModelo';
import { useUnidadesParaFormulario } from '../../hooks/useUnidades';

// ✅ Importa de uma vez todos os itens ativos de uma categoria+tipo do
// catálogo — cria os Servico/ItemVenda de verdade direto (sem passar pelo
// form de criação um por um). Produtos exigem 1 Unidade escolhida antes
// (ItemVenda precisa de unidadesDetalhes não-vazio, ver
// itemVendaValidator.js). Itens já importados antes (mesmo nome+categoria
// já existe na conta) são pulados e aparecem como "Já existe" no resumo.
const ImportarCategoriaModal = ({ grupo, accountId, onClose }) => {
    const [unidadeId, setUnidadeId] = useState('');
    const [resultado, setResultado] = useState(null);

    const precisaUnidade = grupo.tipo === 'produto';

    const { data: unidadesData, isLoading: isLoadingUnidades } = useUnidadesParaFormulario(accountId);
    const unidades = unidadesData?.data || [];

    const importarCategoria = useImportarCategoriaCatalogo();

    const handleConfirmar = () => {
        importarCategoria.mutate(
            {
                categoriaNome: grupo.categoriaNome,
                tipo: grupo.tipo,
                ...(precisaUnidade ? { unidade: unidadeId } : {})
            },
            { onSuccess: (data) => setResultado(data.data) }
        );
    };

    return (
        <FormModal title={`Importar categoria: ${grupo.categoriaNome}`} onClose={onClose}>
            {!resultado ? (
                <div>
                    <p className="form-hint" style={{ marginBottom: 16 }}>
                        Isso vai importar {grupo.itens.length} item(ns) de "{grupo.categoriaNome}" pra
                        sua conta. Itens que você já importou antes (mesmo nome) serão pulados, não
                        duplicados.
                    </p>

                    {precisaUnidade && (
                        <div className="form-group">
                            <label className="form-label required">Unidade</label>
                            <select
                                value={unidadeId}
                                onChange={(e) => setUnidadeId(e.target.value)}
                                className="form-input"
                                disabled={isLoadingUnidades}
                                required
                            >
                                <option value="">Selecione...</option>
                                {unidades.map((u) => (
                                    <option key={u.id || u._id} value={u.id || u._id}>{u.nome}</option>
                                ))}
                            </select>
                            <p className="form-hint">O preço/estoque sugerido de cada produto vai pra essa unidade.</p>
                        </div>
                    )}

                    <div className="form-actions">
                        <button type="button" onClick={onClose} className="action-button action-button-secondary">
                            Cancelar
                        </button>
                        <button
                            type="button"
                            onClick={handleConfirmar}
                            disabled={importarCategoria.isPending || (precisaUnidade && !unidadeId)}
                            className="action-button action-button-primary"
                        >
                            {importarCategoria.isPending ? <Loader2 size={18} className="icon animate-spin" /> : <Download size={18} className="icon" />}
                            Importar {grupo.itens.length} {grupo.itens.length === 1 ? 'item' : 'itens'}
                        </button>
                    </div>
                </div>
            ) : (
                <div>
                    <h4 className="form-section-title">
                        {resultado.totalCriados} criados, {resultado.totalJaExistiam} já existiam, {resultado.totalErros} com erro
                    </h4>
                    <ResultadoImportacaoTable resultados={resultado.resultados} />
                    <div className="form-actions">
                        <button type="button" onClick={onClose} className="action-button action-button-primary">
                            Fechar
                        </button>
                    </div>
                </div>
            )}
        </FormModal>
    );
};

export default ImportarCategoriaModal;
